import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3b55819b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3b55819b&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b55819b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b55819b')) {
      api.createRecord('3b55819b', component.options)
    } else {
      api.reload('3b55819b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3b55819b&scoped=true", function () {
      api.rerender('3b55819b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GuoJiao/historicRecords/index.vue"
export default component.exports